import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  FontWeight,
  StyleBackgroundMessage,
  TypePaintingMessage,
  TypeRankPlayerFormat,
} from "@/domains/settings/chat/constants/chat";

export default function useChatValues() {
  const { t } = useTranslation("chat");

  const fontSizeValues = useMemo(
    () => [
      { label: "12", value: 12 },
      { label: "14", value: 14 },
      { label: "16", value: 16 },
      { label: "18", value: 18 },
      { label: "20", value: 20 },
      { label: "22", value: 22 },
      { label: "24", value: 24 },
    ],
    [],
  );

  const fontWeightValues = useMemo(
    () => [
      { value: FontWeight.Medium, label: t("chat.fontWeight.medium") },
      { value: FontWeight.Semibold, label: t("chat.fontWeight.semibold") },
      { value: FontWeight.Bold, label: t("chat.fontWeight.bold") },
      { value: FontWeight.Extrabold, label: t("chat.fontWeight.extrabold") },
      { value: FontWeight.Black, label: t("chat.fontWeight.black") },
    ],
    [t],
  );

  const opacityTextValues = useMemo(
    () => [
      { label: "0", value: 0 },
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "30", value: 30 },
      { label: "40", value: 40 },
      { label: "50", value: 50 },
      { label: "60", value: 60 },
      { label: "70", value: 70 },
      { label: "80", value: 80 },
      { label: "90", value: 90 },
      { label: "100", value: 100 },
    ],
    [],
  );

  const chatWidthSizeValues = useMemo(
    () => [
      { label: t("chat.chatSize.small"), value: 0 },
      { label: t("chat.chatSize.middle"), value: 1 },
      { label: t("chat.chatSize.large"), value: 2 },
    ],
    [t],
  );

  const chatHeightSizeValues = useMemo(
    () => [
      { label: t("chat.chatSize.small"), value: 0 },
      { label: t("chat.chatSize.middle"), value: 1 },
      { label: t("chat.chatSize.large"), value: 2 },
    ],
    [t],
  );

  const opacityBackgroundValues = useMemo(
    () => [
      { label: "0", value: 0 },
      { label: "10", value: 10 },
      { label: "20", value: 20 },
      { label: "30", value: 30 },
      { label: "40", value: 40 },
      { label: "50", value: 50 },
      { label: "60", value: 60 },
      { label: "70", value: 70 },
      { label: "80", value: 80 },
      { label: "90", value: 90 },
      { label: "100", value: 100 },
    ],
    [],
  );

  const typePaintingMessageValues = useMemo(
    () => [
      { label: t("chat.typePaintingMessage.classic"), value: TypePaintingMessage.Classic },
      { label: t("chat.typePaintingMessage.onlyHeader"), value: TypePaintingMessage.OnlyHeader },
    ],
    [t],
  );

  const styleBackgroundMessageValues = useMemo(
    () => [
      {
        label: t("chat.styleBackgroundMessage.withoutBackground"),
        value: StyleBackgroundMessage.WithoutBackground,
      },
      {
        label: t("chat.styleBackgroundMessage.onlyHeader"),
        value: StyleBackgroundMessage.OnlyHeader,
      },
      {
        label: t("chat.styleBackgroundMessage.headerAndMessage"),
        value: StyleBackgroundMessage.HeaderAndMessage,
      },
    ],
    [t],
  );

  const typeRankPlayerFormatValues = useMemo(
    () => [
      { label: t("chat.typeRankPlayerFormat.text"), value: TypeRankPlayerFormat.Text },
      { label: t("chat.typeRankPlayerFormat.digits"), value: TypeRankPlayerFormat.Digits },
      { label: t("chat.typeRankPlayerFormat.textDigits"), value: TypeRankPlayerFormat.Text_Digits },
    ],
    [t],
  );

  return {
    fontSizeValues,
    fontWeightValues,
    opacityTextValues,
    chatHeightSizeValues,
    chatWidthSizeValues,
    opacityBackgroundValues,
    typePaintingMessageValues,
    styleBackgroundMessageValues,
    typeRankPlayerFormatValues,
  };
}
